import React from "react"
import ZdqConnectorSetup from "../../components/ZdqConnectorSetup"
import { GCP_POSTGRES } from "../../Constants"

function ZdqGcpPostgresConnector() {
    return <ZdqConnectorSetup vendor={GCP_POSTGRES}></ZdqConnectorSetup>
}

export default ZdqGcpPostgresConnector 